
    <div class="receipt">
        <div class="header">
            <h2>Company Name</h2>
        </div>

        <div class="order-info">
            <p><strong>Order #:</strong> {{ printData.orderNumber }}</p>
            <p><strong>Store Name:</strong> {{ printData.retailerName }}</p>
            <p><strong>Store Phone:</strong> {{ printData.retailerPhone }}</p>
            <p><strong>Date:</strong> {{ printData.orderDate | date: "MM-dd-yyyy" }}</p>
            <p><strong>Time:</strong> {{ printData.orderDate | date: "hh:mm:ss a" }}</p>
        </div>

        <div class="sender-receiver-info">
            <p><strong>Sender:</strong> {{ printData.senderName }} - {{ printData.senderPhone }}</p>
            <p><strong>Receiver:</strong> {{ printData.recieverName }} - {{ printData.recieverPhone }}</p>
        </div>

        <div class="items">
            <table>
                <tbody *ngFor="let obj of printData.orderItems">
                    <tr>
                        <td><strong>Product</strong></td>
                        <td>{{ obj.productDisplayText }} x {{ obj.quantity }}</td>
                        
                    </tr>
                    <tr>
                        <td><strong>Price</strong></td>
                        <td>${{ obj.retailPrice }}</td>
                    </tr>
                    <tr>
                        <td><strong>Total Price</strong></td>
                        <td>${{ obj.totalRetailPrice }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="totals">
            <p class="subtotal">Subtotal: ${{ TotalOrderAmount }}</p>
            <p class="total">Total: ${{ TotalOrderAmount }}</p>
        </div>

        <div class="footer">
            <p>Thank you for shopping with us!</p>
            <p>THIS IS STORE COPY ONLY</p>
            <p>For assistance call our toll-free number at 888-774-3542</p>
        </div>
    </div>
